import {
  GET_LIST_CHAT_ROOM,
  GET_LIST_CHAT_ROOM_SUCCESS,
  GET_LIST_CHAT_ROOM_FAILED,
  GET_UNREAD_CHAT_ROOMS_COUNT,
  GET_UNREAD_CHAT_ROOMS_COUNT_SUCCESS,
  GET_UNREAD_CHAT_ROOMS_COUNT_FAILED,
  RESET_UNREAD_CHAT_ROOMS_COUNT,

  RESET_LIST_CHAT_ROOM,

  GET_CHAT_ROOM_DETAIL,
  GET_CHAT_ROOM_DETAIL_SUCCESS,
  GET_CHAT_ROOM_DETAIL_FAILED,

  RESET_CHAT_ROOM_DETAIL,

  GET_CHAT_ROOM_MESSAGES,
  GET_CHAT_ROOM_MESSAGES_SUCCESS,
  GET_CHAT_ROOM_MESSAGES_FAILED,

  RESET_CHAT_ROOM_MESSAGES,

  SEND_CHAT_MESSAGE,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_FAILED,
  SEND_CHAT_MESSAGE_COMPLETED,

  RECEIVE_CHAT_ROOM_MESSAGE,
  RECEIVE_NEW_CHAT_ROOM,
  READ_CHAT_ROOM,
  READ_CHAT_ROOM_SUCCESS,
  READ_CHAT_ROOM_FAILED,
} from './actionTypes';

export const actionGetListChatRoom = (payload) => ({
  payload,
  type: GET_LIST_CHAT_ROOM,
});

export const actionGetListChatRoomSuccess = (payload) => ({
  payload,
  type: GET_LIST_CHAT_ROOM_SUCCESS,
});

export const actionGetListChatRoomFailed = (payload) => ({
  payload,
  type: GET_LIST_CHAT_ROOM_FAILED,
});

export const actionGetUnreadChatRoomsCount = (payload) => ({
  payload,
  type: GET_UNREAD_CHAT_ROOMS_COUNT,
});

export const actionGetUnreadChatRoomsCountSuccess = (payload) => ({
  payload,
  type: GET_UNREAD_CHAT_ROOMS_COUNT_SUCCESS,
});

export const actionGetUnreadChatRoomsCountFailed = () => ({
  type: GET_UNREAD_CHAT_ROOMS_COUNT_FAILED,
});

export const actionResetUnreadChatRoomsCount = (payload) => ({
  payload,
  type: RESET_UNREAD_CHAT_ROOMS_COUNT,
});

export const actionResetListChatRoom = () => ({
  type: RESET_LIST_CHAT_ROOM,
});

export const actionGetChatRoomDetail = (payload) => ({
  payload,
  type: GET_CHAT_ROOM_DETAIL,
});

export const actionGetChatRoomDetailSuccess = (payload) => ({
  payload,
  type: GET_CHAT_ROOM_DETAIL_SUCCESS,
});

export const actionGetChatRoomDetailFailed = (payload) => ({
  payload,
  type: GET_CHAT_ROOM_DETAIL_FAILED,
});

export const actionResetChatRoomDetail = () => ({
  type: RESET_CHAT_ROOM_DETAIL,
});

export const actionGetChatRoomMessages = (payload) => ({
  payload,
  type: GET_CHAT_ROOM_MESSAGES,
});

export const actionGetChatRoomMessagesSuccess = (payload) => ({
  payload,
  type: GET_CHAT_ROOM_MESSAGES_SUCCESS,
});

export const actionGetChatRoomMessagesFailed = (payload) => ({
  payload,
  type: GET_CHAT_ROOM_MESSAGES_FAILED,
});

export const actionResetChatRoomMessages = () => ({
  type: RESET_CHAT_ROOM_MESSAGES,
});

export const actionSendChatMessage = (payload) => ({
  payload,
  type: SEND_CHAT_MESSAGE,
});

export const actionSendChatMessageSuccess = (payload) => ({
  payload,
  type: SEND_CHAT_MESSAGE_SUCCESS,
});

export const actionSendChatMessageFailed = (payload) => ({
  payload,
  type: SEND_CHAT_MESSAGE_FAILED,
});

export const actionSendChatMessageCompleted = () => ({
  type: SEND_CHAT_MESSAGE_COMPLETED,
});

export const actionReceiveChatRoomMessage = (payload) => ({
  payload,
  type: RECEIVE_CHAT_ROOM_MESSAGE,
});

export const actionReceiveNewChatRoom = (payload) => ({
  payload,
  type: RECEIVE_NEW_CHAT_ROOM,
});

export const actionReadChatRoom = (payload) => ({
  payload,
  type: READ_CHAT_ROOM,
});

export const actionReadChatRoomSuccess = (payload) => ({
  payload,
  type: READ_CHAT_ROOM_SUCCESS,
});

export const actionReadChatRoomFailed = () => ({
  type: READ_CHAT_ROOM_FAILED,
});
